<template>
  <div class="card-header row">
    <h4
      v-if="selected_hopper === null"
      class="text-center mt-1 ms-4"
    >
      Select Hopper
    </h4>
    <label
      v-if="selected_hopper !== null"
      class="mt-2 mb-2"
    >
      Selected Hopper
    </label>
    <div
      class="mt-2 mb-2"
      :style="{
        position: 'relative',
        pointerEvents: hoppers.length === 1 || lock_dropdown ? 'none' : 'auto',
      }"
      @click.stop="hoppers.length > 1 && (hopperDropdownVisible = !hopperDropdownVisible)"
    >
      <button class="form-control">
        {{
          selected_hopper
            ? selected_hopper.name
            : hoppers.length > 0
              ? "Click here to select a Hopper"
              : "No Hoppers to select"
        }}
      </button>
      <div
        v-if="hopperDropdownVisible"
        class="dropdown-menu show w-100"
        style="border: 1px solid #ccc; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1)"
      >
        <input
          v-model="searchQueryHopper"
          class="form-control mt-1 mb-2 ms-2 w-90"
          type="text"
          placeholder="Search..."
          @click.stop
        />
        <div
          v-for="hopper in filteredHoppers"
          :key="hopper.id"
          class="dropdown-item"
          style="cursor: pointer"
          @click="updateSelectedHopper(hopper)"
        >
          {{ hopper.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted } from "vue";

const props = defineProps({
  hoppers: {
    type: Array,
    default: () => [],
  },
  selected_hopper: {
    type: Object,
    default: null,
  },
  lock_dropdown: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(["update:selected_hopper"]);

const hopperDropdownVisible = ref(false);
const searchQueryHopper = ref("");
// eslint-disable-next-line no-unused-vars
const filteredHoppers = computed(() =>
  props.hoppers.filter(hopper => hopper.name.toLowerCase().includes(searchQueryHopper.value.toLowerCase())),
);

function updateSelectedHopper(hopper) {
  if (hopper !== props.selected_hopper) {
    searchQueryHopper.value = "";
    emits("update:selected_hopper", hopper);
  }
}

function closeDropdown() {
  hopperDropdownVisible.value = false;
}

onMounted(() => {
  document.addEventListener("click", closeDropdown);
});

watch(
  () => props.hoppers,
  newHoppers => {
    if (newHoppers.length === 1) {
      updateSelectedHopper(newHoppers[0]);
    }
  },
  { immediate: true },
);
watch(
  () => props.selected_hopper,
  newSelectedHopper => {
    if (newSelectedHopper == null && props.hoppers.length === 1) {
      updateSelectedHopper(props.hoppers[0]);
    }
  },
);
</script>

<style scoped>
.dropdown-menu.show {
  position: relative;
  display: block;
}
</style>
